import SVG from './image.svg';
import { face } from '~/notations';

export default {
  SVG,
  algorithm: [
    face.r.two,
    face.u.pri,
    face.b.two,
    [
      face.u.two,
      face.r.two,
      face.u.pri,
      face.r.two,
    ],
  ],
  name: 'UB & DB',
};
